import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage } from "@/features/profile/profile-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

export const Route = createFileRoute("/_authenticated/profile")({
  staticData: { crumb: { label: STATIC_LABELS.profile } },
  component: ProfilePage,
});
